import Cookies from 'universal-cookie';
import { parse } from '@wkda/cid-parser';
export function getCIDCookie(req) {
  const cookies = new Cookies(req?.headers?.cookie);
  return parse(cookies.get('WKDA'));
}